module.exports = __webpack_public_path__ + "img/hys-3.e10cd985.webp";